export default {"src":"/_next/static/media/navier-logo.333e472b.svg","height":49,"width":118,"blurWidth":0,"blurHeight":0};